import React from "react";

export enum ApplicationEnvironment {
  SinglePortal,
  GlobalPortal,
  Staff,
}

export const ApplicationContext = React.createContext(ApplicationEnvironment.SinglePortal);
